import http from '../http'
import { Res } from '../type'
import { AppSkin } from '../Models/AppSkin'
import { AppSupportLanguage } from '../Models/AppSupportLanguage'
import { AppLanguagesDict } from '../Models/AppLanguagesDict'
import { BackgroundUrl, CountryCode, LanguageVersion, TenantAuthenticationParams, UserLabelInfo } from '../Models/CountryCode'

export const getAppSkin = (): Res<AppSkin> => {
  return http.request({
    url: '/sands-lms/api/v1/skin/get',
    method: 'get',
    loadingShow: '0'
  })
}

// 语言类型
export const getAppSupportLanguage = (params: { tenantId: string }): Res<AppSupportLanguage[]> => {
  return http.request({
    url: '/sands-operation/api/v1/language/listAvailable',
    method: 'get',
    loadingShow: '0',
    params,
    unLogin: '1'
  })
}

// 语言配置
export const getAppLanguagesDict = (params?: { moduleCode?: string }): Res<AppLanguagesDict[]> => {
  return http.request({
    url: '/sands-operation/api/v1/translate/i18ns',
    method: 'get',
    loadingShow: '0',
    unLogin: '1',
    params
  })
}

// 短链接相关接口-获取短链接
export const getShortURL = (params: { shortUrl: string }): Res<string | undefined> => {
  return http.request({
    url: '/sands-system/api/v1/short-url/getShortUrl',
    method: 'get',
    params
  })
}

// 生成短链接
export const generatorShortUrl = (data: {
  clientType: string
  jumpType: number | string
  jumpId: number | string
  extendInfo?: string
  tenantId?: string
}): Res<string> => {
  return http.request({
    url: '/sands-system/api/v1/short-url/generatorShortUrl',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

type WeimobLogin = { appTicket: string; appClientId: string }
export const postWeimobLogin = (data: {}): Res<WeimobLogin> => {
  return http.request({
    url: '/sands-lms/api/v1/weimob/login',
    method: 'post',
    data
  })
}

// 短信国家列表
export const getCountryCode = (): Res<CountryCode> => {
  return http.request({
    url: '/sands-system/api/v1/sms/country-list',
    method: 'get',
    loadingShow: '0'
  })
}

// 获取多语言版本号
export const getLanguageVersion = (): Res<LanguageVersion> => {
  return http.request({
    url: '/sands-operation/api/v1/translate/version/get',
    method: 'get',
    loadingShow: '0',
    unLogin: '1'
  })
}

// 租户认证
export const getTenantAuthentication = (data: { code: string, domainName: string }): Res<TenantAuthenticationParams> => {
  return http.request({
    url: '/sands-user/api/v1/auth/authorization-tenant',
    method: 'POST',
    data,
    loadingShow: '0',
    toastShow: '0'
  })
}

// 租户认证
export const getAllTenantAuthentication = (data: { code: string, domainName: string }): Res<TenantAuthenticationParams> => {
  return http.request({
    url: '/sands-user/api/v1/auth/authorization-tenant',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 企业系统全局配置 type 标识符类型(1-租户ID，2-租户域名)
export const getBranding = (params: { clientType: number, identifier: string, type: number }): Res<BackgroundUrl> => {
  return http.request({
    url: '/sands-user/api/v1/auth/branding',
    method: 'get',
    params,
    loadingShow: '0',
    toastShow: '0'
  })
}

// 获取用户标签信息
export const getUserLabelInfo = (): Res<UserLabelInfo> => {
  return http.request({
    url: '/sands-user/api/v1/user/label-info',
    method: 'get',
    loadingShow: '0',
    toastShow: '0'
  })
}
